"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagMap = exports.CSS = void 0;
const mithril_component_1 = require("../../components/mithril.component");
const theme_1 = require("../../components/theme");
const dom_1 = require("../../dom");
const mithril_1 = require("../../mithril");
const services_1 = require("../../services");
const tag_map_overlay_1 = require("./tag.map.overlay");
exports.CSS = {
    container: 'c-Map',
};
(0, theme_1.addStyles)({
    [exports.CSS.container]: {
        width: '100%',
        height: '100%',
    },
});
class TagMap extends mithril_component_1.IMithrilComponent {
    constructor(state, mapContext) {
        super();
        this.name = 'TagMap';
        this.map = null;
        this.overlay = null;
        this.streetModeListener = null;
        this.mapTypeListener = null;
        this.enterTime = null;
        this.state = state;
        this.mapContext = mapContext;
    }
    onCreate(vnode) {
        this.map = services_1.Services.Map.attach(vnode.dom);
        this.state.map.setMap(this.map);
        this.map.setMapTypeId(services_1.Services.Map.getMapType(this.mapContext, 'roadmap'));
        this.map.set('streetViewControl', true);
        this.mapTypeListener = services_1.Services.Map.listenMapType(this.mapContext);
        this.overlay = new tag_map_overlay_1.CustomMapOverlay(this.state.map, this.map);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'map:create', 'create', 1);
        this.streetModeListener = this.map.getStreetView().addListener('visible_changed', () => this.trackStreetViewMode());
    }
    onRemove() {
        if (this.overlay) {
            this.overlay.setMap(null);
        }
        if (this.streetModeListener) {
            this.streetModeListener.remove();
        }
        if (this.mapTypeListener) {
            this.mapTypeListener.remove();
        }
    }
    onBeforeRemove(vnode) {
        if (this.overlay) {
            this.overlay.setMap(null);
        }
        if (this.streetModeListener) {
            this.streetModeListener.remove();
        }
        if (this.mapTypeListener) {
            this.mapTypeListener.remove();
        }
    }
    get nodes() {
        if (!services_1.Services.Map.isReady) {
            return null;
        }
        return (0, mithril_1.m)('div', {
            className: exports.CSS.container,
            onmousemove: dom_1.handleMouseMove,
            onclick: (e) => this.handleMouseClick(e),
        });
    }
    handleMouseClick(e) {
        const node = (0, dom_1.findDragonNode)(e);
        if (node == null) {
            return;
        }
        if (e.preventDefault) {
            e.preventDefault();
        }
        const id = node.getAttribute(dom_1.DRAGON_ID);
        const type = node.getAttribute(dom_1.DRAGON_TYPE);
        this.state.map.zoomToId(type, id);
    }
    trackStreetViewMode() {
        var _a;
        if (this.map == null) {
            return;
        }
        const panorama = this.map.getStreetView();
        if (panorama.getVisible()) {
            this.enterTime = Date.now();
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:enter');
        }
        else {
            services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'streetview:exit', null, Date.now() - ((_a = this.enterTime) !== null && _a !== void 0 ? _a : 0));
        }
    }
}
exports.TagMap = TagMap;
//# sourceMappingURL=tag.map.js.map